import React from 'react';

function isValidUrl(url) {
    const pattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return pattern.test(url);
}

function parseTextWithLinks(text) {
    const regex = /\[([^\]]+)\]\(([^)]+)\)/g;
    return text.replace(regex, (match, title, url) => {
        if (isValidUrl(url)) {
            return `<a target="_blank" href="${url}">${title}</a>`;
        } else {
            return match;
        }
    });
}

function TextWithLinksParser({ text }) {
    const parsedText = parseTextWithLinks(text);
    return <span dangerouslySetInnerHTML={{ __html: parsedText }} />;
}

export default TextWithLinksParser;
